module.exports = __webpack_public_path__ + "img/btn-save.d972fdd9.svg";